unit Unit1;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WebLib.WebTools,
  WEBLib.ComCtrls, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Menus, WEBLib.Menus,
  WEBLib.Buttons, XData.Web.JsonDataset, XData.Web.Dataset, math,
  WEBLib.Lists, WEBLib.Storage, WEBLib.REST, strutils, XData.Web.Connection,
  XData.Web.Client, WEBLib.Grids, WEBLib.WebCtrls, Vcl.Imaging.pngimage, DB;

type
  TForm1 = class(TForm)
    xdsAnmeldung: TXDataWebDataSet;
    xdsAnmeldungKundennummer: TStringField;
    xdsAnmeldungLoginPW: TStringField;
    xdsAnmeldungNachname: TStringField;
    xdsAnmeldungVorname: TStringField;
    xdsAnmeldungEMail: TStringField;
    WebHttpRequest1: THttpRequest;
    WebMessageDlg1: TMessageDlg;
    WebHttpRequest2: THttpRequest;
    AuthConnection: TXDataWebConnection;
    WClient: TXDataWebClient;
    xdsAnmeldungLoginAktiv: TIntegerField;
    xdsAnmeldungPseudonymisiert: TStringField;
    xdsAnmeldungNichtInListeAnzeigen: TBooleanField;
    TopPanel: TPanel;
    lblKundenportal: TLabel;
    WebPanel1: TPanel;
    buttonDatenschutz: TButton;
    buttonAGB: TButton;
    buttonImpressum: TButton;
    buttonLogout: TButton;
    labelonlinestatus: TLabel;
    PanelMain: TPanel;
    panelCookies: TPanel;
    WebLabel5: TLabel;
    btnCookiesEinverstanden: TButton;
    btnNoCookies: TButton;
    btnCookieInfo: TButton;
    labelversion: TLabel;
    BoxAnmeldung: TPanel;
    lblchecklogin: TLabel;
    edtBenutzer: TEdit;
    edtPassword: TEdit;
    buttonLogin: TButton;
    btnPasswortVergessen: TButton;
    WebLabel1: TLabel;
    btnKundendaten: TButton;
    btnSupportAnfordern: TButton;
    btnSupportTickets: TButton;
    btnRechnungen: TButton;
    TC: TTableControl;
    WebLabel2: TLabel;
    btnBestellungen: TButton;
    WebHTMLDiv1: THTMLDiv;
    XDSVertreter: TXDataWebDataSet;
    XDSVertreterKundennummer: TXDataWebEntityField;
    XDSVertreterVertreterMatchcode: TStringField;
    XDSVertreterVertreternummer: TStringField;
    XDSVertreterNachname: TStringField;
    XDSVertreterVorname: TStringField;
    XDSVertreterProvisionssatz: TFloatField;
    XDSVertreterVertreterStatus: TStringField;
    btnVertreterProvisionen: TButton;
    btnNachrichten: TButton;
    xdskdppw: TXDataWebDataSet;
    xdskdppwLINKID: TStringField;
    xdskdppwKundennummer: TStringField;
    xdskdppwDatum: TDateTimeField;
    xdskdppwBenutzt: TDateTimeField;
    btnactivation: TButton;
    btnZugangAktivieren: TButton;
    btnSupportKonto: TButton;
    procedure WebFormShow(Sender: TObject);


    procedure xdsAnmeldungAfterOpen(DataSet: TDataSet);
    procedure btnKundendatenClick(Sender: TObject);
    procedure btnRechnungenClick(Sender: TObject);
    procedure btnSupportAnfordernClick(Sender: TObject);
    procedure btnSupportTicketsClick(Sender: TObject);
    procedure btnCookiesEinverstandenClick(Sender: TObject);
    procedure btnCookieInfoClick(Sender: TObject);
    procedure btnNoCookiesClick(Sender: TObject);
    procedure WebHttpRequest1Response(Sender: TObject; AResponse: string);
    procedure btnPasswortVergessenClick(Sender: TObject);
    procedure WebHttpRequest2Response(Sender: TObject; AResponse: string);
    procedure AuthConnectionConnect(Sender: TObject);
    procedure buttonAGBClick(Sender: TObject);
    procedure buttonImpressumClick(Sender: TObject);
    procedure buttonDatenschutzClick(Sender: TObject);
    procedure buttonLogoutClick(Sender: TObject);
    procedure edtBenutzerKeyPress(Sender: TObject; var Key: Char);
    procedure edtPasswordKeyPress(Sender: TObject; var Key: Char);
    procedure buttonLoginClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure btnBestellungenClick(Sender: TObject);
    procedure WebHttpRequest1Error(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
      var Handled: Boolean);
    procedure BoxAnmeldungDblClick(Sender: TObject);
    procedure XDSVertreterAfterOpen(DataSet: TDataSet);
    procedure btnVertreterProvisionenClick(Sender: TObject);
    procedure btnNachrichtenClick(Sender: TObject);
    procedure xdskdppwAfterOpen(DataSet: TDataSet);
    procedure btnactivationClick(Sender: TObject);
    procedure btnZugangAktivierenClick(Sender: TObject);
    procedure WebFormBeforeUnload(Sender: TObject; var AMessage: string);
    procedure btnSupportKontoClick(Sender: TObject);

  public
    webverlassen:string;

    type
      TLieferanschriftR = Record
        Nachname:string;
        Vorname: string;
        Adresszeile2: string;
        Adresszeile3: string;
        Strasse: string;
        Postleitzahl: string;
        Ort: string;
        Laenderkuerzel: string;
        Land: string;
        Adressanrede: string;
        Titel: string;
        Adressebild: string;
        Bundesland: string;
        Telefon: string;
        LEmail: string;
    End;

    var LAR:TLieferanschriftR;
    var LARLIST:TStringList;
    procedure LARLISTtoRECORD;
    procedure LARLISTfromRECORD;
    procedure LARadresseberechnen;
    procedure LARleeren;

    procedure setcontrols;
    procedure Tokenholen(Username, Password: string);
    function XorStr(const Text: string; Key: Integer): string;
    procedure NewsletterAbmelden;
  protected procedure LoadDFMValues; override; end;

const
  Versionslabel1='©2011-2025 Cadia Software GmbH ';
  Versionslabel2='Version 4.3.0 | 24.05.2025';
  Versionslabel3=' <a href="https://www.cadia.de" target="_blank">(cadia-Webseite)</a>';
  CadiaAppKey='991783253';
  CadiaAppKeyServerLizenz='123458420';
var
  Form1: TForm1;
  Versionslabel:string;
  xdataDATASERVER:string;
  BenutzerAngemeldet:Boolean;
  KundeEmail:string;
  KundePasswort:string;
  KundeKundennummer:string;
  KundeNachname:string;
  KundeVorname:string;
  IstVertreter:boolean;
  vtoken:string;
  ajahr, amonat, atag,astunde,aminute,asekunde,ams:word;
  xdataconnectionstring:string;
  xdataauthconnection:string;
  downloadconnection:string;
  xdatausername:string;
  xdatapassword:string;
  QueryParamEmail:string;
  QueryParamPasswort:string;
  QueryParamAktion:string;
  QueryParamZucode:string;
  QueryParamAPID:string;
  QueryParamKundennummer:string;
  QueryParamNewsletterAbmelden:string;
  CookiesAkzeptiert:boolean;
  InternetIpAdresse:string;
  Fensterbreite:integer;
  Fensterhoehe:integer;
  LizenzOK:boolean;

  MyLinkImpressum:string;
  MyLinkDatenschutz:string;
  MyLinkAGB:string;
  MyEmailKonto:string;
  MyEmailFromName:string;
implementation
  uses unit2, unit_Passwortanforderung,
  unit_Kundendaten, unit_Rechnungen, unit_Nachrichten, unit_PasswortVergeben, unit_Aktivierung,
  unit_Tickets, unit_Support, unit_Bestellungen, unit_Provisionsabrechnungen, unit_Supportkonto, unit_AbmeldungNewsletter;
{$R *.dfm}

procedure TForm1.AuthConnectionConnect(Sender: TObject);
begin
  Tokenholen(xdatausername,xdatapassword);
end;

procedure TForm1.XDSVertreterAfterOpen(DataSet: TDataSet);
begin
  if XDSVertreter.RecordCount>0 then IstVertreter:=true else IstVertreter:=false;
  SetControls;
end;

procedure TForm1.NewsletterAbmelden;
var
  LFrm:TAbmeldungNewsletter;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TAbmeldungNewsletter;
    begin
      LForm:=(AForm as TAbmeldungNewsletter);
      LForm.AbmKundennummer:=QueryParamKundennummer;
      LForm.AbmEmail:=QueryParamEmail;
      LForm.AbmAPID:=QueryParamAPID;
      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      BenutzerAngemeldet:=false;
      setcontrols;
    end;
  begin
    LFrm:=TAbmeldungNewsletter.CreateNew(@AfterCreate);
    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);

end;

function TForm1.XorStr(const Text: string; Key: Integer): string;
var
  i: Integer;
begin
  SetLength(Result, Length(Text));
  for i:=1 to Length(Text) do
  begin
    if Text[i] > #31 then
      Result[i] := Chr(Ord(Text[i]) xor Key)
    else
      Result[i] := Text[i];
  end;
end;

procedure TForm1.btnCookiesEinverstandenClick(Sender: TObject);
var
  mylocalstorage:TLocalStorage;
begin
  mylocalstorage:=TLocalStorage.Create(nil);
  mylocalstorage.setvalue('CookiesAkzeptiertAm',datetimetostr(date));
  mylocalstorage.Free;
  CookiesAkzeptiert:=true;
  setcontrols;
end;

procedure TForm1.btnKundendatenClick(Sender: TObject);
var
  LFrm:TKundendaten;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TKundendaten;
    begin
      LForm:=(AForm as TKundendaten);

      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    if BenutzerAngemeldet=true then
    begin
    LFrm:=TKundendaten.CreateNew(@AfterCreate);
    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);
    end;


end;

procedure TForm1.btnNachrichtenClick(Sender: TObject);
var
  LFrm:TNachrichten;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TNachrichten;
    begin
      LForm:=(AForm as TNachrichten);

      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    if BenutzerAngemeldet=true then
    begin
    LFrm:=TNachrichten.CreateNew(@AfterCreate);
    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);
    end;

end;

procedure TForm1.btnNoCookiesClick(Sender: TObject);
begin
  showmessage('Sofern Sie Cookies nicht akzeptieren, können wir Ihnen die Leistungen auf dieser Webseite nicht bereitstellen');
end;

procedure TForm1.btnPasswortVergessenClick(Sender: TObject);
var
  LFrm:TPasswortanforderung;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TPasswortanforderung;
    begin
      LForm:=(AForm as TPasswortanforderung);

      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TPasswortanforderung.CreateNew(@AfterCreate);

    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnRechnungenClick(Sender: TObject);
var
  LFrm:TRechnungen;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TRechnungen;
    begin
      LForm:=(AForm as TRechnungen);


    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //noch implementieren
    end;
  begin
    if BenutzerAngemeldet=true then
    begin
    LFrm:=TRechnungen.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);
    end;

end;

procedure TForm1.btnSupportAnfordernClick(Sender: TObject);
var
  LFrm:TSupport;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TSupport;
    begin
      LForm:=(AForm as TSupport);

      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TSupport.CreateNew(@AfterCreate);
    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnSupportKontoClick(Sender: TObject);
var
  LFrm:TSupportKonto;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TSupportKonto;
    begin
      LForm:=(AForm as TSupportKonto);
      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TSupportKonto.CreateNew(@AfterCreate);
    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnSupportTicketsClick(Sender: TObject);
var
  LFrm:TTickets;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TTickets;
    begin
      LForm:=(AForm as TTickets);

      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TTickets.CreateNew(@AfterCreate);
    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnVertreterProvisionenClick(Sender: TObject);
var
  LFrm:TProvisionsabrechnungen;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TProvisionsabrechnungen;
    begin
      LForm:=(AForm as TProvisionsabrechnungen);


    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //noch implementieren
    end;
  begin
    if BenutzerAngemeldet=true then
    begin
    LFrm:=TProvisionsabrechnungen.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);
    end;
end;

procedure TForm1.btnZugangAktivierenClick(Sender: TObject);
var
  Aktivierung:TAktivierung;
begin
  Aktivierung := TAktivierung.CreateNew;
end;

procedure TForm1.setcontrols;
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  //WebImageControl1.Picture:=nil;
  //webimagecontrol1.URL:='resources\logo_kundenportal.png';

  if MyLinkAGB<>'' then buttonAGB.Visible:=true else buttonAGB.Visible:=false;
  if MyLinkDatenschutz<>'' then buttonDatenschutz.Visible:=true else buttonDatenschutz.Visible:=false;
  if MyLinkImpressum<>'' then buttonImpressum.Visible:=true else buttonImpressum.Visible:=false;

  BoxAnmeldung.Visible:=false;
  if CookiesAkzeptiert=true then
  begin
    panelcookies.Visible:=false;
    BoxAnmeldung.Visible:=true;
    buttonlogout.Visible:=false;
    if BenutzerAngemeldet then
    begin
      buttonLogout.Visible:=true;
      labelonlinestatus.html:='<h6>User: '+KundeKundennummer+' | '+KundeEmail+' | '+KundeNachname+', '+KundeVorname;
      BoxAnmeldung.Visible:=false;
      TC.Visible:=true;


    end
    else
    begin
      labelonlinestatus.html:='<h6>Sie sind nicht angemeldet';
      TC.Visible:=false;
      BoxAnmeldung.Visible:=true;

      if edtbenutzer.Text='' then edtbenutzer.SetFocus else edtPassword.setfocus;
    end;
  end
  else
  begin
    panelcookies.Visible:=true;
    BoxAnmeldung.Visible:=false;
    TC.Visible:=false;
  end;

  if BoxAnmeldung.Visible then
  begin
    BoxAnmeldung.left:=trunc((fensterbreite-300)/2);
    Boxanmeldung.Top:=panelCookies.Top;
  end;
  if TC.Visible then
  begin
    TC.left:=trunc((fensterbreite-300)/2);
    TC.Top:=panelCookies.Top;
  end;
  i:=0;
  if LizenzOK then
  begin
    WebLabel2.ElementClassName:='badge badge-primary';
    weblabel2.Caption:='Menü';
    myelement:=TC.cellelements[0,i];
    weblabel2.ParentElement:=myelement;
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnKundendaten.ParentElement:=myelement;
    btnkundendaten.Visible:=true;
    btnkundendaten.Width:=225;
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnSupportAnfordern.ParentElement:=myelement;
    btnSupportAnfordern.Visible:=true;
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnSupportTickets.ParentElement:=myelement;
    btnSupportTickets.Visible:=true;
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnSupportKonto.ParentElement:=myelement;
    btnSupportKonto.Visible:=true;
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnBestellungen.ParentElement:=myelement;
    btnBestellungen.Visible:=true;
    btnBestellungen.Width:=225;
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnRechnungen.ParentElement:=myelement;
    btnRechnungen.Visible:=true;
    btnRechnungen.Width:=225;
    inc(i);
    myelement:=TC.cellelements[0,i];
    btnNachrichten.ParentElement:=myelement;
    btnNachrichten.Visible:=true;
    btnNachrichten.Width:=225;

    if IstVertreter=true then
    begin
      inc(i);
      myelement:=TC.cellelements[0,i];
      btnVertreterProvisionen.ParentElement:=myelement;
      btnVertreterProvisionen.Visible:=true;
      btnVertreterProvisionen.Width:=225;
    end;
  end;
  if not LizenzOK then
  begin
    Weblabel2.ElementClassName:='badge badge-danger';
    weblabel2.Caption:='Keine Lizenz für Kundenportal gefunden';
    myelement:=TC.cellelements[0,i];
    weblabel2.ParentElement:=myelement;
  end;

  if (fensterhoehe-toppanel.height-webpanel1.Height-30)>400 then
  begin
  PanelMain.Height:=fensterhoehe-toppanel.height-webpanel1.Height-30;
  end
  else
  begin
    PanelMain.Height:=400;
  end;
end;

procedure TForm1.BoxAnmeldungDblClick(Sender: TObject);
begin
  edtbenutzer.Text:='10015';
  edtpassword.Text:='9zsEWZx3';
end;

procedure TForm1.btnactivationClick(Sender: TObject);
var
  LFrm:TPasswortVergeben;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TPasswortVergeben;
    begin
      LForm:=(AForm as TPasswortVergeben);


    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //noch implementieren
    end;
  begin
    LFrm:=TPasswortVergeben.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);


end;

procedure TForm1.btnBestellungenClick(Sender: TObject);
var
  LFrm:TBestellungen;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TBestellungen;
    begin
      LForm:=(AForm as TBestellungen);


    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //noch implementieren
    end;
  begin
    if BenutzerAngemeldet=true then
    begin
    LFrm:=TBestellungen.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);
    end;

end;

procedure TForm1.btnCookieInfoClick(Sender: TObject);
begin
  application.Navigate(MyLinkDatenschutz,ntblank);
end;

procedure TForm1.WebFormBeforeUnload(Sender: TObject; var AMessage: string);
begin
 AMessage:=webverlassen;
end;

procedure TForm1.WebFormResize(Sender: TObject);
begin
  fensterbreite:=window.innerWidth;
  fensterhoehe:=window.innerHeight;
  setcontrols;
end;

procedure TForm1.WebFormShow(Sender: TObject);
var
  mylocalstorage:TLocalStorage;
  v:string;
  lastKundennummer:string;
  v1:TDateTime;
  myelement:TJSHTMLElement;
  mymenueelement:TJSHTMLElement;
  i:integer;
begin
  Application.InitFormatSettings('de');
  Application.InsertCSS('themecss','resources\theme.css');
  Versionslabel:=Versionslabel1+Versionslabel2+Versionslabel3;
  labelversion.html:=Versionslabel;
  IstVertreter:=false;
  LARLIST:=TStringList.Create;
  LARLIST.NameValueSeparator:='|';
  webverlassen:='CadiaWEB verlassen?';
  CookiesAkzeptiert:=false;
  mylocalstorage:=Tlocalstorage.Create(nil);
  v:= mylocalstorage.GetValue('CookiesAkzeptiertAm');
  lastKundennummer:=mylocalstorage.GetValue('LastKundennummer');
  TryStrToDate(v,v1);
  mylocalstorage.Free;
  if v1>(date-10) then CookiesAkzeptiert:=true;
  labelonlinestatus.html:='Sie sind nicht angemeldet';

  queryparamemail:=getqueryparam('Email');
  QueryParamPasswort:=getqueryparam('Passwort');
  QueryParamAktion:=getqueryparam('Aktion');
  QueryParamZucode:=getqueryparam('zucode');
  QueryParamAPID:=getqueryparam('APID');
  QueryParamKundennummer:=getqueryparam('Kundennummer');
  QueryParamNewsletterAbmelden:=getqueryparam('NewsletterAbmelden');
  if QueryParamEmail<>'' then edtBenutzer.Text:=QueryParamEmail;
  if QueryParamPasswort<>'' then edtPassword.Text:=QueryParamPasswort;

  try
    WebHttpRequest1.Execute;
  except

  end;
  webhttprequest2.Execute;
  setcontrols;


end;



procedure TForm1.WebHttpRequest1Error(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
  var Handled: Boolean);
begin
handled:=true;
end;

procedure TForm1.WebHttpRequest1Response(Sender: TObject; AResponse: string);
var
  myresp:string;
  mystartpos:integer;
  mylaenge:integer;
begin
  myresp:=aresponse;
  mylaenge:=Length(myresp);
  if pos('IPADR',myresp)>0 then mystartpos:=pos('IPADR',myresp);
  myresp:=rightstr(myresp,mylaenge-mystartpos-4);
  mylaenge:=length(myresp);
  if pos('</BODY',myresp)>0 then mystartpos:=pos('</BODY',myresp);
  myresp:=leftstr(myresp,mystartpos-1);
  InternetIpAdresse:=myresp;
  if length(InternetIpAdresse)>200 then InternetIpAdresse:=leftstr(InternetIpAdresse,20);

end;

procedure TForm1.WebHttpRequest2Response(Sender: TObject; AResponse: string);
var
  RStringList:TStringList;
  s:string;
begin
  if aresponse='' then
  begin
    showmessage('Die Konfigurationsdatei ist nicht vorhanden oder fehlerhaft');
    exit;
  end;
  if aresponse<>'' then
  begin
    RStringList:=TStringList.Create;
    RStringList.Text:=aresponse;
    s:= XorStr(RStringList.Strings[0],25);
    xdataDATASERVER:=trim(ReplaceStr(s,'DATASERVER=',''));

    if RightStr(xdataDATASERVER,1)<>'/' then xdataDATASERVER:=xdataDATASERVER+'/';
    xdataconnectionstring:=xdataDATASERVER+'cadiaserver/xdata';
    downloadconnection:=xdataDATASERVER+'cadiaserver/filedownload?FileName=';
    xdataauthconnection:=xdataDATASERVER+'cadiaserverauth';
    s:= XorStr(RStringList.Strings[1],25);

    xdatausername:=trim(ReplaceStr(s,'USERNAME=',''));
    s:= XorStr(RStringList.Strings[2],25);
    xdatapassword:=trim(ReplaceStr(s,'PASSWORD=',''));
    AuthConnection.Connected:=false;
    AuthConnection.URL:=xdataauthconnection;
    authconnection.Connected:=true;

  end;

end;

procedure TForm1.xdsAnmeldungAfterOpen(DataSet: TDataSet);
var
  mylocalstorage:TLocalStorage;
begin
  if xdsAnmeldung.RecordCount<1 then
  begin
    lblchecklogin.Caption:='Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut mit den richtigen Eingaben';
    xdsAnmeldung.Close;
    exit;
  end;

  xdsAnmeldung.First;
  if (xdsAnmeldungLoginPW.AsString=KundePasswort) AND (xdsAnmeldungKundennummer.AsString=KundeKundennummer) then
  begin
    BenutzerAngemeldet:=true;
    KundeEmail:=xdsAnmeldungEMail.AsString;
    KundeNachname:=xdsAnmeldungNachname.AsString;
    KundeVorname:=xdsAnmeldungVorname.AsString;
    labelonlinestatus.html:='Anmeldung erfolgreich';
    mylocalstorage:=Tlocalstorage.Create(nil);
    mylocalstorage.SetValue('LastKundennummer',KundeKundennummer);
    mylocalstorage.Free;
    xdsVertreter.Close;
    xdsVertreter.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
    xdsVertreter.Load;
  end
  else
  begin
    lblchecklogin.Caption:='Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut mit den richtigen Eingaben';

  end;
  xdsAnmeldung.Close;

end;

procedure TForm1.xdskdppwAfterOpen(DataSet: TDataSet);
begin
  if xdskdppw.RecordCount=1 then
  begin
    if xdskdppwDatum.AsDateTime>(date-1) then
    begin
      KundeKundennummer:=xdskdppwKundennummer.AsString;
      btnactivationClick(nil);
    end;
  end;
end;

procedure TForm1.Tokenholen(Username, Password: string);
  procedure OnResponse(Response:TXDataClientResponse);
  begin
    labelonlinestatus.html:='Token erhalten';
    vtoken:=string(TJSObject(response.Result)['value']);
    if xdataconnectionstring<>'' then
    begin
      dm2.XDataWebConnection1.url:=xdataconnectionstring;
      dm2.xdatawebconnection1.Connected:=true;

      setcontrols;
      if QueryParamZucode<>'' then
      begin
    // automatische Anmeldung und Passwort festlegen
        xdskdppw.Close;
        xdskdppw.QueryString:='$filter=LINKID eq '+QueryParamZucode;
        xdskdppw.Load;
      end;
      if QueryParamNewsletterAbmelden='1' then
      begin
        if (QueryParamKundennummer<>'') AND (QueryParamEmail<>'') then NewsletterAbmelden;
      end;
    end;
  end;
begin
  labelonlinestatus.html:='hole token';
  WClient.RawInvoke('ILoginService.Login',[Username,Password],@OnResponse);
end;


procedure TForm1.buttonloginclick(Sender:TObject);
var
  mylocalstorage:TLocalStorage;
begin

  lblchecklogin.Caption:='';
  if edtbenutzer.text='' then
  begin
    lblchecklogin.Caption:='Sie müssen Ihre Kundennummer eingeben';
    edtbenutzer.SetFocus;
    exit;
  end;
  if edtPassword.text='' then
  begin
    lblchecklogin.Caption:='Sie müssen Ihr Passwort eingeben';
    edtpassword.SetFocus;
    exit;
  end;
  if edtbenutzer.text='superuser' then
  begin
    lblchecklogin.Caption:='Diesen Benutzer dürfen Sie im WebPortal nicht verwenden';
    edtbenutzer.SetFocus;
    exit;
  end;
  KundeKundennummer:=edtbenutzer.text;
  KundePasswort:=edtpassword.text;
  xdsAnmeldung.Close;
  xdsAnmeldung.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsAnmeldung.Load;
end;

procedure TForm1.buttonLogoutClick(Sender: TObject);
begin
  BenutzerAngemeldet:=false;
  setcontrols;
end;

procedure TForm1.edtBenutzerKeyPress(Sender: TObject; var Key: Char);
begin
if key=#13 then edtPassword.SetFocus;
end;

procedure TForm1.edtPasswordKeyPress(Sender: TObject; var Key: Char);
begin
if key=#13 then buttonloginClick(sender);
end;

procedure TForm1.buttonAGBClick(Sender: TObject);
begin
  application.Navigate(MyLinkAGB,ntblank);
end;

procedure TForm1.buttonImpressumClick(Sender: TObject);
begin
  application.Navigate(MyLinkImpressum,ntblank);
end;

procedure TForm1.buttonDatenschutzclick(Sender:TObject);
begin
  application.Navigate(MyLinkDatenschutz,ntblank);
end;

procedure TForm1.LARLISTtoRECORD;
begin
  LAR.Adressanrede:=larlist.Values['Adressanrede'];
  LAR.Titel:=larlist.Values['Titel'];
  LAR.Nachname:=larlist.Values['Nachname'];
  LAR.Vorname:=larlist.Values['Vorname'];
  LAR.Adresszeile2:=larlist.Values['Adresszeile2'];
  LAR.Adresszeile3:=larlist.Values['Adresszeile3'];
  LAR.Strasse:=larlist.Values['Strasse'];
  LAR.Postleitzahl:=larlist.Values['Postleitzahl'];
  LAR.Ort:=larlist.Values['Ort'];
  LAR.Laenderkuerzel:=larlist.Values['Laenderkuerzel'];
  LAR.Land:=larlist.Values['Land'];
  LAR.Bundesland:=larlist.Values['Bundesland'];
  LAR.Telefon:=larlist.Values['Telefon'];
end;

procedure TForm1.LARLISTfromRECORD;
begin
  LARLIST.Clear;
  LARLIST.Add('Nachname|'+LAR.Nachname);
  LARLIST.Add('Vorname|'+LAR.Vorname);
  LARLIST.Add('Adresszeile2|'+LAR.Adresszeile2);
  LARLIST.Add('Adresszeile3|'+LAR.Adresszeile3);
  LARLIST.Add('Strasse|'+LAR.Strasse);
  LARLIST.Add('Postleitzahl|'+LAR.Postleitzahl);
  LARLIST.Add('Ort|'+LAR.Ort);
  LARLIST.Add('Laenderkuerzel|'+LAR.Laenderkuerzel);
  LARLIST.Add('Land|'+LAR.Land);
  LARLIST.Add('Adressanrede|'+LAR.Adressanrede);
  LARLIST.Add('Titel|'+LAR.Titel);
  LARLIST.Add('Bundesland|'+LAR.Bundesland);
  LARLIST.Add('Telefon|'+LAR.Telefon);
end;

procedure TForm1.LARadresseberechnen;
var
  adrbild:string;
begin
  adrbild:='';
  if length(lar.adressanrede)>1 then
  begin
    adrbild:=adrbild + lar.adressanrede+chr(13)+chr(10);
  end;
  if (length(lar.titel)>1) then
  begin
    adrbild:=adrbild + lar.titel+' ';
  end;
  if length(lar.Vorname)>1 then
  begin
    adrbild:=adrbild + lar.Vorname+' ';
  end;
  adrbild:=adrbild + lar.Nachname+chr(13)+chr(10);
  if length(lar.Adresszeile2)>0 then
  begin
    adrbild:=adrbild + lar.Adresszeile2+chr(13)+chr(10);
  end;
  if length(lar.Adresszeile3)>0 then
  begin
    adrbild:=adrbild + lar.Adresszeile3+chr(13)+chr(10);
  end;
  adrbild:=adrbild + lar.Strasse+chr(13)+chr(10);
  if LAR.Laenderkuerzel<>dm2.tablesysdatLaenderkuerzel.asstring then
  begin
    adrbild:=adrbild + lar.Postleitzahl+ ' ';
    adrbild:=adrbild + uppercase(lar.Ort)+chr(13)+chr(10);
    adrbild:=adrbild + uppercase(lar.Land);
  end
  else
  begin
    adrbild:=adrbild + lar.Postleitzahl+ ' ';
    adrbild:=adrbild + lar.Ort;
  end;
  if LAR.Telefon<>'' then adrbild:=adrbild+chr(13)+chr(10)+LAR.Telefon;
  LAR.Adressebild:=adrbild;
end;

procedure TForm1.LARleeren;
begin
  LAR.Adressanrede:='';
  LAR.Titel:='';
  LAR.Nachname:='';
  LAR.Vorname:='';
  LAR.Adresszeile2:='';
  LAR.Adresszeile3:='';
  LAR.Strasse:='';
  LAR.Postleitzahl:='';
  LAR.Ort:='';
  LAR.Laenderkuerzel:='';
  LAR.Land:='';
  LAR.Adressebild:='';
  LAR.Bundesland:='';
  LAR.Telefon:='';
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebMessageDlg1 := TMessageDlg.Create(Self);
  TopPanel := TPanel.Create(Self);
  lblKundenportal := TLabel.Create(Self);
  labelonlinestatus := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  btnKundendaten := TButton.Create(Self);
  btnSupportAnfordern := TButton.Create(Self);
  btnSupportTickets := TButton.Create(Self);
  btnRechnungen := TButton.Create(Self);
  btnBestellungen := TButton.Create(Self);
  WebHTMLDiv1 := THTMLDiv.Create(Self);
  btnactivation := TButton.Create(Self);
  btnVertreterProvisionen := TButton.Create(Self);
  btnSupportKonto := TButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  buttonDatenschutz := TButton.Create(Self);
  buttonAGB := TButton.Create(Self);
  buttonImpressum := TButton.Create(Self);
  buttonLogout := TButton.Create(Self);
  PanelMain := TPanel.Create(Self);
  labelversion := TLabel.Create(Self);
  panelCookies := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  btnCookiesEinverstanden := TButton.Create(Self);
  btnNoCookies := TButton.Create(Self);
  btnCookieInfo := TButton.Create(Self);
  BoxAnmeldung := TPanel.Create(Self);
  lblchecklogin := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  edtBenutzer := TEdit.Create(Self);
  edtPassword := TEdit.Create(Self);
  buttonLogin := TButton.Create(Self);
  btnPasswortVergessen := TButton.Create(Self);
  btnZugangAktivieren := TButton.Create(Self);
  TC := TTableControl.Create(Self);
  btnNachrichten := TButton.Create(Self);
  xdsAnmeldung := TXDataWebDataSet.Create(Self);
  xdsAnmeldungKundennummer := TStringField.Create(Self);
  xdsAnmeldungLoginPW := TStringField.Create(Self);
  xdsAnmeldungNachname := TStringField.Create(Self);
  xdsAnmeldungVorname := TStringField.Create(Self);
  xdsAnmeldungEMail := TStringField.Create(Self);
  xdsAnmeldungLoginAktiv := TIntegerField.Create(Self);
  xdsAnmeldungPseudonymisiert := TStringField.Create(Self);
  xdsAnmeldungNichtInListeAnzeigen := TBooleanField.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  WebHttpRequest2 := THttpRequest.Create(Self);
  AuthConnection := TXDataWebConnection.Create(Self);
  WClient := TXDataWebClient.Create(Self);
  XDSVertreter := TXDataWebDataSet.Create(Self);
  XDSVertreterKundennummer := TXDataWebEntityField.Create(Self);
  XDSVertreterVertreterMatchcode := TStringField.Create(Self);
  XDSVertreterVertreternummer := TStringField.Create(Self);
  XDSVertreterNachname := TStringField.Create(Self);
  XDSVertreterVorname := TStringField.Create(Self);
  XDSVertreterProvisionssatz := TFloatField.Create(Self);
  XDSVertreterVertreterStatus := TStringField.Create(Self);
  xdskdppw := TXDataWebDataSet.Create(Self);
  xdskdppwLINKID := TStringField.Create(Self);
  xdskdppwKundennummer := TStringField.Create(Self);
  xdskdppwDatum := TDateTimeField.Create(Self);
  xdskdppwBenutzt := TDateTimeField.Create(Self);

  WebMessageDlg1.BeforeLoadDFMValues;
  TopPanel.BeforeLoadDFMValues;
  lblKundenportal.BeforeLoadDFMValues;
  labelonlinestatus.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  btnKundendaten.BeforeLoadDFMValues;
  btnSupportAnfordern.BeforeLoadDFMValues;
  btnSupportTickets.BeforeLoadDFMValues;
  btnRechnungen.BeforeLoadDFMValues;
  btnBestellungen.BeforeLoadDFMValues;
  WebHTMLDiv1.BeforeLoadDFMValues;
  btnactivation.BeforeLoadDFMValues;
  btnVertreterProvisionen.BeforeLoadDFMValues;
  btnSupportKonto.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  buttonDatenschutz.BeforeLoadDFMValues;
  buttonAGB.BeforeLoadDFMValues;
  buttonImpressum.BeforeLoadDFMValues;
  buttonLogout.BeforeLoadDFMValues;
  PanelMain.BeforeLoadDFMValues;
  labelversion.BeforeLoadDFMValues;
  panelCookies.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  btnCookiesEinverstanden.BeforeLoadDFMValues;
  btnNoCookies.BeforeLoadDFMValues;
  btnCookieInfo.BeforeLoadDFMValues;
  BoxAnmeldung.BeforeLoadDFMValues;
  lblchecklogin.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  edtBenutzer.BeforeLoadDFMValues;
  edtPassword.BeforeLoadDFMValues;
  buttonLogin.BeforeLoadDFMValues;
  btnPasswortVergessen.BeforeLoadDFMValues;
  btnZugangAktivieren.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  btnNachrichten.BeforeLoadDFMValues;
  xdsAnmeldung.BeforeLoadDFMValues;
  xdsAnmeldungKundennummer.BeforeLoadDFMValues;
  xdsAnmeldungLoginPW.BeforeLoadDFMValues;
  xdsAnmeldungNachname.BeforeLoadDFMValues;
  xdsAnmeldungVorname.BeforeLoadDFMValues;
  xdsAnmeldungEMail.BeforeLoadDFMValues;
  xdsAnmeldungLoginAktiv.BeforeLoadDFMValues;
  xdsAnmeldungPseudonymisiert.BeforeLoadDFMValues;
  xdsAnmeldungNichtInListeAnzeigen.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  WebHttpRequest2.BeforeLoadDFMValues;
  AuthConnection.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  XDSVertreter.BeforeLoadDFMValues;
  XDSVertreterKundennummer.BeforeLoadDFMValues;
  XDSVertreterVertreterMatchcode.BeforeLoadDFMValues;
  XDSVertreterVertreternummer.BeforeLoadDFMValues;
  XDSVertreterNachname.BeforeLoadDFMValues;
  XDSVertreterVorname.BeforeLoadDFMValues;
  XDSVertreterProvisionssatz.BeforeLoadDFMValues;
  XDSVertreterVertreterStatus.BeforeLoadDFMValues;
  xdskdppw.BeforeLoadDFMValues;
  xdskdppwLINKID.BeforeLoadDFMValues;
  xdskdppwKundennummer.BeforeLoadDFMValues;
  xdskdppwDatum.BeforeLoadDFMValues;
  xdskdppwBenutzt.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 728;
    Height := 551;
    CSSLibrary := cssBootstrap;
    ElementClassName := 'bg-primary mainform';
    ElementFont := efCSS;
    SetEvent(Self, 'OnBeforeUnload', 'WebFormBeforeUnload');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebMessageDlg1.SetParentComponent(Self);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 17;
    WebMessageDlg1.Top := 36;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    WebMessageDlg1.ElementButtonClassName := 'btn';
    WebMessageDlg1.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    WebMessageDlg1.ElementTitleClassName := 'text-body';
    WebMessageDlg1.ElementContentClassName := 'text-body';
    TopPanel.SetParentComponent(Self);
    TopPanel.Name := 'TopPanel';
    TopPanel.AlignWithMargins := True;
    TopPanel.Left := 3;
    TopPanel.Top := 3;
    TopPanel.Width := 722;
    TopPanel.Height := 82;
    TopPanel.ElementClassName := 'card shadow p-3 mb-5 bg-primary rounded';
    TopPanel.HeightStyle := ssAuto;
    TopPanel.WidthPercent := 95.000000000000000000;
    TopPanel.Align := alTop;
    TopPanel.Caption := 'TopPanel';
    TopPanel.ChildOrder := 8;
    TopPanel.ElementBodyClassName := 'card-body';
    TopPanel.ElementFont := efCSS;
    TopPanel.ShowCaption := False;
    TopPanel.TabOrder := 1;
    lblKundenportal.SetParentComponent(TopPanel);
    lblKundenportal.Name := 'lblKundenportal';
    lblKundenportal.AlignWithMargins := True;
    lblKundenportal.Left := 3;
    lblKundenportal.Top := 3;
    lblKundenportal.Width := 72;
    lblKundenportal.Height := 15;
    lblKundenportal.Caption := 'Kundenportal';
    lblKundenportal.ElementClassName := 'h2';
    lblKundenportal.ElementFont := efCSS;
    lblKundenportal.HeightStyle := ssAuto;
    lblKundenportal.HeightPercent := 100.000000000000000000;
    lblKundenportal.WidthPercent := 100.000000000000000000;
    labelonlinestatus.SetParentComponent(TopPanel);
    labelonlinestatus.Name := 'labelonlinestatus';
    labelonlinestatus.AlignWithMargins := True;
    labelonlinestatus.Left := 3;
    labelonlinestatus.Top := 48;
    labelonlinestatus.Width := 89;
    labelonlinestatus.Height := 15;
    labelonlinestatus.Caption := 'labelonlinestatus';
    labelonlinestatus.HeightStyle := ssAuto;
    labelonlinestatus.HeightPercent := 100.000000000000000000;
    labelonlinestatus.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(TopPanel);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 16;
    WebLabel2.Top := 20;
    WebLabel2.Width := 31;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Men'#252;
    WebLabel2.ElementClassName := 'badge badge-primary';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    btnKundendaten.SetParentComponent(TopPanel);
    btnKundendaten.Name := 'btnKundendaten';
    btnKundendaten.Left := 3;
    btnKundendaten.Top := 7;
    btnKundendaten.Width := 120;
    btnKundendaten.Height := 35;
    btnKundendaten.Caption := 'Kundendaten';
    btnKundendaten.ChildOrder := 9;
    btnKundendaten.ElementClassName := 'btn btn-info';
    btnKundendaten.ElementFont := efCSS;
    btnKundendaten.HeightStyle := ssAuto;
    btnKundendaten.HeightPercent := 100.000000000000000000;
    btnKundendaten.Visible := False;
    btnKundendaten.WidthPercent := 100.000000000000000000;
    SetEvent(btnKundendaten, Self, 'OnClick', 'btnKundendatenClick');
    btnSupportAnfordern.SetParentComponent(TopPanel);
    btnSupportAnfordern.Name := 'btnSupportAnfordern';
    btnSupportAnfordern.Left := 3;
    btnSupportAnfordern.Top := 42;
    btnSupportAnfordern.Width := 225;
    btnSupportAnfordern.Height := 35;
    btnSupportAnfordern.Caption := 'Hilfe anfordern';
    btnSupportAnfordern.ChildOrder := 9;
    btnSupportAnfordern.ElementClassName := 'btn btn-info';
    btnSupportAnfordern.ElementFont := efCSS;
    btnSupportAnfordern.HeightStyle := ssAuto;
    btnSupportAnfordern.HeightPercent := 100.000000000000000000;
    btnSupportAnfordern.Visible := False;
    btnSupportAnfordern.WidthPercent := 100.000000000000000000;
    SetEvent(btnSupportAnfordern, Self, 'OnClick', 'btnSupportAnfordernClick');
    btnSupportTickets.SetParentComponent(TopPanel);
    btnSupportTickets.Name := 'btnSupportTickets';
    btnSupportTickets.Left := 127;
    btnSupportTickets.Top := 7;
    btnSupportTickets.Width := 225;
    btnSupportTickets.Height := 35;
    btnSupportTickets.Caption := 'Support-Tickets';
    btnSupportTickets.ChildOrder := 9;
    btnSupportTickets.ElementClassName := 'btn btn-info';
    btnSupportTickets.ElementFont := efCSS;
    btnSupportTickets.HeightStyle := ssAuto;
    btnSupportTickets.HeightPercent := 100.000000000000000000;
    btnSupportTickets.Visible := False;
    btnSupportTickets.WidthPercent := 100.000000000000000000;
    SetEvent(btnSupportTickets, Self, 'OnClick', 'btnSupportTicketsClick');
    btnRechnungen.SetParentComponent(TopPanel);
    btnRechnungen.Name := 'btnRechnungen';
    btnRechnungen.Left := 84;
    btnRechnungen.Top := 25;
    btnRechnungen.Width := 113;
    btnRechnungen.Height := 35;
    btnRechnungen.Caption := 'Rechnungen';
    btnRechnungen.ChildOrder := 9;
    btnRechnungen.ElementClassName := 'btn btn-info';
    btnRechnungen.ElementFont := efCSS;
    btnRechnungen.HeightStyle := ssAuto;
    btnRechnungen.HeightPercent := 100.000000000000000000;
    btnRechnungen.Visible := False;
    btnRechnungen.WidthPercent := 100.000000000000000000;
    SetEvent(btnRechnungen, Self, 'OnClick', 'btnRechnungenClick');
    btnBestellungen.SetParentComponent(TopPanel);
    btnBestellungen.Name := 'btnBestellungen';
    btnBestellungen.Left := 190;
    btnBestellungen.Top := 25;
    btnBestellungen.Width := 113;
    btnBestellungen.Height := 35;
    btnBestellungen.Caption := 'Bestellungen';
    btnBestellungen.ChildOrder := 9;
    btnBestellungen.ElementClassName := 'btn btn-info';
    btnBestellungen.ElementFont := efCSS;
    btnBestellungen.HeightStyle := ssAuto;
    btnBestellungen.HeightPercent := 100.000000000000000000;
    btnBestellungen.Visible := False;
    btnBestellungen.WidthPercent := 100.000000000000000000;
    SetEvent(btnBestellungen, Self, 'OnClick', 'btnBestellungenClick');
    WebHTMLDiv1.SetParentComponent(TopPanel);
    WebHTMLDiv1.Name := 'WebHTMLDiv1';
    WebHTMLDiv1.AlignWithMargins := True;
    WebHTMLDiv1.Left := 518;
    WebHTMLDiv1.Top := 3;
    WebHTMLDiv1.Width := 201;
    WebHTMLDiv1.Height := 76;
    WebHTMLDiv1.Align := alRight;
    WebHTMLDiv1.ChildOrder := 8;
    WebHTMLDiv1.ElementFont := efCSS;
    WebHTMLDiv1.HTML.BeginUpdate;
    try
      WebHTMLDiv1.HTML.Clear;
      WebHTMLDiv1.HTML.Add('<img src="resources/logo_kundenportal.png" class="img-fluid" alt="logo">');
    finally
      WebHTMLDiv1.HTML.EndUpdate;
    end;
    WebHTMLDiv1.Role := '';
    btnactivation.SetParentComponent(WebHTMLDiv1);
    btnactivation.Name := 'btnactivation';
    btnactivation.Left := 56;
    btnactivation.Top := 16;
    btnactivation.Width := 96;
    btnactivation.Height := 25;
    btnactivation.Caption := 'btnactivation';
    btnactivation.ElementClassName := 'btn';
    btnactivation.ElementFont := efCSS;
    btnactivation.HeightStyle := ssAuto;
    btnactivation.HeightPercent := 100.000000000000000000;
    btnactivation.Visible := False;
    btnactivation.WidthPercent := 100.000000000000000000;
    SetEvent(btnactivation, Self, 'OnClick', 'btnactivationClick');
    btnVertreterProvisionen.SetParentComponent(TopPanel);
    btnVertreterProvisionen.Name := 'btnVertreterProvisionen';
    btnVertreterProvisionen.Left := 92;
    btnVertreterProvisionen.Top := 33;
    btnVertreterProvisionen.Width := 113;
    btnVertreterProvisionen.Height := 35;
    btnVertreterProvisionen.Caption := 'Vertreter Provisionen';
    btnVertreterProvisionen.ChildOrder := 9;
    btnVertreterProvisionen.ElementClassName := 'btn btn-info';
    btnVertreterProvisionen.ElementFont := efCSS;
    btnVertreterProvisionen.HeightStyle := ssAuto;
    btnVertreterProvisionen.HeightPercent := 100.000000000000000000;
    btnVertreterProvisionen.Visible := False;
    btnVertreterProvisionen.WidthPercent := 100.000000000000000000;
    SetEvent(btnVertreterProvisionen, Self, 'OnClick', 'btnVertreterProvisionenClick');
    btnSupportKonto.SetParentComponent(TopPanel);
    btnSupportKonto.Name := 'btnSupportKonto';
    btnSupportKonto.Left := 358;
    btnSupportKonto.Top := 12;
    btnSupportKonto.Width := 225;
    btnSupportKonto.Height := 35;
    btnSupportKonto.Caption := 'Support-Konto';
    btnSupportKonto.ChildOrder := 9;
    btnSupportKonto.ElementClassName := 'btn btn-info';
    btnSupportKonto.ElementFont := efCSS;
    btnSupportKonto.HeightStyle := ssAuto;
    btnSupportKonto.HeightPercent := 100.000000000000000000;
    btnSupportKonto.Visible := False;
    btnSupportKonto.WidthPercent := 100.000000000000000000;
    SetEvent(btnSupportKonto, Self, 'OnClick', 'btnSupportKontoClick');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.AlignWithMargins := True;
    WebPanel1.Left := 3;
    WebPanel1.Top := 88;
    WebPanel1.Width := 722;
    WebPanel1.Height := 60;
    WebPanel1.Margins.Top := 0;
    WebPanel1.Margins.Bottom := 0;
    WebPanel1.ElementClassName := 'bg-info rounded';
    WebPanel1.HeightStyle := ssAuto;
    WebPanel1.Align := alTop;
    WebPanel1.Caption := 'WebPanel1';
    WebPanel1.ChildOrder := 9;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebPanel1.ShowCaption := False;
    WebPanel1.TabOrder := 2;
    buttonDatenschutz.SetParentComponent(WebPanel1);
    buttonDatenschutz.Name := 'buttonDatenschutz';
    buttonDatenschutz.AlignWithMargins := True;
    buttonDatenschutz.Left := 105;
    buttonDatenschutz.Top := 3;
    buttonDatenschutz.Width := 96;
    buttonDatenschutz.Height := 54;
    buttonDatenschutz.Align := alLeft;
    buttonDatenschutz.Caption := 'Datenschutz/Disclaimer';
    buttonDatenschutz.ChildOrder := 1;
    buttonDatenschutz.ElementClassName := 'btn btn-sm btn-primary text-left mr-1';
    buttonDatenschutz.ElementFont := efCSS;
    buttonDatenschutz.HeightStyle := ssAuto;
    buttonDatenschutz.HeightPercent := 100.000000000000000000;
    buttonDatenschutz.WidthStyle := ssAuto;
    buttonDatenschutz.WidthPercent := 100.000000000000000000;
    SetEvent(buttonDatenschutz, Self, 'OnClick', 'buttonDatenschutzClick');
    buttonAGB.SetParentComponent(WebPanel1);
    buttonAGB.Name := 'buttonAGB';
    buttonAGB.AlignWithMargins := True;
    buttonAGB.Left := 3;
    buttonAGB.Top := 3;
    buttonAGB.Width := 96;
    buttonAGB.Height := 54;
    buttonAGB.Align := alLeft;
    buttonAGB.Caption := 'AGB';
    buttonAGB.ChildOrder := 1;
    buttonAGB.ElementClassName := 'btn btn-sm btn-primary text-left mr-1';
    buttonAGB.ElementFont := efCSS;
    buttonAGB.HeightStyle := ssAuto;
    buttonAGB.HeightPercent := 100.000000000000000000;
    buttonAGB.WidthStyle := ssAuto;
    buttonAGB.WidthPercent := 100.000000000000000000;
    SetEvent(buttonAGB, Self, 'OnClick', 'buttonAGBClick');
    buttonImpressum.SetParentComponent(WebPanel1);
    buttonImpressum.Name := 'buttonImpressum';
    buttonImpressum.AlignWithMargins := True;
    buttonImpressum.Left := 207;
    buttonImpressum.Top := 3;
    buttonImpressum.Width := 96;
    buttonImpressum.Height := 54;
    buttonImpressum.Align := alLeft;
    buttonImpressum.Caption := 'Impressum';
    buttonImpressum.ChildOrder := 1;
    buttonImpressum.ElementClassName := 'btn btn-sm btn-primary text-left mr-1';
    buttonImpressum.ElementFont := efCSS;
    buttonImpressum.HeightStyle := ssAuto;
    buttonImpressum.HeightPercent := 100.000000000000000000;
    buttonImpressum.WidthStyle := ssAuto;
    buttonImpressum.WidthPercent := 100.000000000000000000;
    SetEvent(buttonImpressum, Self, 'OnClick', 'buttonImpressumClick');
    buttonLogout.SetParentComponent(WebPanel1);
    buttonLogout.Name := 'buttonLogout';
    buttonLogout.AlignWithMargins := True;
    buttonLogout.Left := 309;
    buttonLogout.Top := 3;
    buttonLogout.Width := 96;
    buttonLogout.Height := 54;
    buttonLogout.Align := alLeft;
    buttonLogout.Caption := 'Logout';
    buttonLogout.ChildOrder := 1;
    buttonLogout.ElementClassName := 'btn btn-sm btn-primary text-left mr-1';
    buttonLogout.ElementFont := efCSS;
    buttonLogout.HeightStyle := ssAuto;
    buttonLogout.HeightPercent := 100.000000000000000000;
    buttonLogout.WidthStyle := ssAuto;
    buttonLogout.WidthPercent := 100.000000000000000000;
    SetEvent(buttonLogout, Self, 'OnClick', 'buttonLogoutClick');
    PanelMain.SetParentComponent(Self);
    PanelMain.Name := 'PanelMain';
    PanelMain.AlignWithMargins := True;
    PanelMain.Left := 3;
    PanelMain.Top := 151;
    PanelMain.Width := 722;
    PanelMain.Height := 400;
    PanelMain.ElementClassName := 'bg-secondary rounded';
    PanelMain.Align := alTop;
    PanelMain.Caption := 'PanelMain';
    PanelMain.ChildOrder := 7;
    PanelMain.ElementBodyClassName := 'card-body';
    PanelMain.ElementFont := efCSS;
    PanelMain.ShowCaption := False;
    PanelMain.TabOrder := 3;
    labelversion.SetParentComponent(PanelMain);
    labelversion.Name := 'labelversion';
    labelversion.AlignWithMargins := True;
    labelversion.Left := 3;
    labelversion.Top := 381;
    labelversion.Width := 716;
    labelversion.Height := 16;
    labelversion.Align := alBottom;
    labelversion.Alignment := taCenter;
    labelversion.AutoSize := False;
    labelversion.Caption := 'labelversion';
    labelversion.ElementClassName := 'label';
    labelversion.ElementLabelClassName := 'h6 center';
    labelversion.ElementFont := efCSS;
    labelversion.HeightStyle := ssAuto;
    labelversion.HeightPercent := 100.000000000000000000;
    labelversion.WidthPercent := 100.000000000000000000;
    panelCookies.SetParentComponent(PanelMain);
    panelCookies.Name := 'panelCookies';
    panelCookies.AlignWithMargins := True;
    panelCookies.Left := 3;
    panelCookies.Top := 3;
    panelCookies.Width := 716;
    panelCookies.Height := 168;
    panelCookies.ElementClassName := 'bg-warning rounded';
    panelCookies.Align := alTop;
    panelCookies.Caption := 'panelCookies';
    panelCookies.ChildOrder := 8;
    panelCookies.Color := clCoral;
    panelCookies.ElementBodyClassName := 'card-body';
    panelCookies.ElementFont := efCSS;
    panelCookies.ShowCaption := False;
    panelCookies.TabOrder := 0;
    WebLabel5.SetParentComponent(panelCookies);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.AlignWithMargins := True;
    WebLabel5.Left := 3;
    WebLabel5.Top := 3;
    WebLabel5.Width := 710;
    WebLabel5.Height := 15;
    WebLabel5.Align := alTop;
    WebLabel5.Caption := 'Diese Webseite benutzt Cookies. Wenn Sie die Webseite weiterbenutzen, gehen wir von Ihrem Einverst'#228'ndnis aus.';
    WebLabel5.ElementClassName := 'h3';
    WebLabel5.ElementFont := efCSS;
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WordWrap := True;
    WebLabel5.WidthStyle := ssAuto;
    WebLabel5.WidthPercent := 100.000000000000000000;
    btnCookiesEinverstanden.SetParentComponent(panelCookies);
    btnCookiesEinverstanden.Name := 'btnCookiesEinverstanden';
    btnCookiesEinverstanden.Left := 14;
    btnCookiesEinverstanden.Top := 124;
    btnCookiesEinverstanden.Width := 64;
    btnCookiesEinverstanden.Height := 25;
    btnCookiesEinverstanden.Caption := 'OK';
    btnCookiesEinverstanden.ChildOrder := 1;
    btnCookiesEinverstanden.ElementClassName := 'btn btn btn-info text-left';
    btnCookiesEinverstanden.ElementFont := efCSS;
    btnCookiesEinverstanden.HeightStyle := ssAuto;
    btnCookiesEinverstanden.HeightPercent := 100.000000000000000000;
    btnCookiesEinverstanden.WidthStyle := ssAuto;
    btnCookiesEinverstanden.WidthPercent := 100.000000000000000000;
    SetEvent(btnCookiesEinverstanden, Self, 'OnClick', 'btnCookiesEinverstandenClick');
    btnNoCookies.SetParentComponent(panelCookies);
    btnNoCookies.Name := 'btnNoCookies';
    btnNoCookies.Left := 124;
    btnNoCookies.Top := 124;
    btnNoCookies.Width := 77;
    btnNoCookies.Height := 25;
    btnNoCookies.Caption := 'NEIN';
    btnNoCookies.ChildOrder := 1;
    btnNoCookies.ElementClassName := 'btn btn btn-info text-left';
    btnNoCookies.ElementFont := efCSS;
    btnNoCookies.HeightStyle := ssAuto;
    btnNoCookies.HeightPercent := 100.000000000000000000;
    btnNoCookies.WidthStyle := ssAuto;
    btnNoCookies.WidthPercent := 100.000000000000000000;
    SetEvent(btnNoCookies, Self, 'OnClick', 'btnNoCookiesClick');
    btnCookieInfo.SetParentComponent(panelCookies);
    btnCookieInfo.Name := 'btnCookieInfo';
    btnCookieInfo.Left := 242;
    btnCookieInfo.Top := 124;
    btnCookieInfo.Width := 72;
    btnCookieInfo.Height := 25;
    btnCookieInfo.Caption := 'INFOS';
    btnCookieInfo.ChildOrder := 1;
    btnCookieInfo.ElementClassName := 'btn btn btn-primary text-left';
    btnCookieInfo.ElementFont := efCSS;
    btnCookieInfo.HeightStyle := ssAuto;
    btnCookieInfo.HeightPercent := 100.000000000000000000;
    btnCookieInfo.WidthStyle := ssAuto;
    btnCookieInfo.WidthPercent := 100.000000000000000000;
    SetEvent(btnCookieInfo, Self, 'OnClick', 'btnCookieInfoClick');
    BoxAnmeldung.SetParentComponent(PanelMain);
    BoxAnmeldung.Name := 'BoxAnmeldung';
    BoxAnmeldung.Left := 393;
    BoxAnmeldung.Top := -25;
    BoxAnmeldung.Width := 190;
    BoxAnmeldung.Height := 400;
    BoxAnmeldung.ElementClassName := 'card shadow p-3 mb-5 bg-info rounded';
    BoxAnmeldung.Anchors := [];
    BoxAnmeldung.Caption := 'WebPanelMenue';
    BoxAnmeldung.ChildOrder := 2;
    BoxAnmeldung.Color := 8340248;
    BoxAnmeldung.ElementBodyClassName := 'card-body';
    BoxAnmeldung.ElementFont := efCSS;
    BoxAnmeldung.ShowCaption := False;
    BoxAnmeldung.TabOrder := 1;
    SetEvent(BoxAnmeldung, Self, 'OnDblClick', 'BoxAnmeldungDblClick');
    lblchecklogin.SetParentComponent(BoxAnmeldung);
    lblchecklogin.Name := 'lblchecklogin';
    lblchecklogin.AlignWithMargins := True;
    lblchecklogin.Left := 3;
    lblchecklogin.Top := 316;
    lblchecklogin.Width := 9;
    lblchecklogin.Height := 15;
    lblchecklogin.Margins.Top := 20;
    lblchecklogin.Caption := '...';
    lblchecklogin.ElementClassName := 'label ';
    lblchecklogin.ElementLabelClassName := 'text-danger';
    lblchecklogin.ElementFont := efCSS;
    lblchecklogin.HeightStyle := ssAuto;
    lblchecklogin.HeightPercent := 100.000000000000000000;
    lblchecklogin.WordWrap := True;
    lblchecklogin.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(BoxAnmeldung);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 13;
    WebLabel1.Width := 153;
    WebLabel1.Height := 16;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Anmeldung';
    WebLabel1.ElementLabelClassName := 'h4 center';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    edtBenutzer.SetParentComponent(BoxAnmeldung);
    edtBenutzer.Name := 'edtBenutzer';
    edtBenutzer.Left := 11;
    edtBenutzer.Top := 55;
    edtBenutzer.Width := 161;
    edtBenutzer.Height := 22;
    edtBenutzer.ChildOrder := 3;
    edtBenutzer.ElementClassName := 'form-control';
    edtBenutzer.ElementFont := efCSS;
    edtBenutzer.HeightStyle := ssAuto;
    edtBenutzer.HeightPercent := 100.000000000000000000;
    edtBenutzer.TextHint := 'Kundennummer';
    edtBenutzer.WidthPercent := 100.000000000000000000;
    SetEvent(edtBenutzer, Self, 'OnKeyPress', 'edtBenutzerKeyPress');
    edtPassword.SetParentComponent(BoxAnmeldung);
    edtPassword.Name := 'edtPassword';
    edtPassword.Left := 11;
    edtPassword.Top := 111;
    edtPassword.Width := 161;
    edtPassword.Height := 22;
    edtPassword.ChildOrder := 4;
    edtPassword.ElementClassName := 'form-control';
    edtPassword.ElementFont := efCSS;
    edtPassword.HeightStyle := ssAuto;
    edtPassword.HeightPercent := 100.000000000000000000;
    edtPassword.PasswordChar := '*';
    edtPassword.TextHint := 'Passwort';
    edtPassword.WidthPercent := 100.000000000000000000;
    SetEvent(edtPassword, Self, 'OnKeyPress', 'edtPasswordKeyPress');
    buttonLogin.SetParentComponent(BoxAnmeldung);
    buttonLogin.Name := 'buttonLogin';
    buttonLogin.Left := 11;
    buttonLogin.Top := 169;
    buttonLogin.Width := 163;
    buttonLogin.Height := 41;
    buttonLogin.Caption := 'Anmelden';
    buttonLogin.ChildOrder := 3;
    buttonLogin.ElementClassName := 'btn btn-primary text-center mr-1';
    buttonLogin.ElementFont := efCSS;
    buttonLogin.HeightStyle := ssAuto;
    buttonLogin.HeightPercent := 100.000000000000000000;
    buttonLogin.TabOrder := 2;
    buttonLogin.WidthPercent := 100.000000000000000000;
    SetEvent(buttonLogin, Self, 'OnClick', 'buttonLoginClick');
    btnPasswortVergessen.SetParentComponent(BoxAnmeldung);
    btnPasswortVergessen.Name := 'btnPasswortVergessen';
    btnPasswortVergessen.Left := 11;
    btnPasswortVergessen.Top := 217;
    btnPasswortVergessen.Width := 161;
    btnPasswortVergessen.Height := 41;
    btnPasswortVergessen.Caption := 'Passwort anfordern';
    btnPasswortVergessen.ChildOrder := 3;
    btnPasswortVergessen.ElementClassName := 'btn btn-sm btn-primary text-center mr-1';
    btnPasswortVergessen.ElementFont := efCSS;
    btnPasswortVergessen.HeightStyle := ssAuto;
    btnPasswortVergessen.HeightPercent := 100.000000000000000000;
    btnPasswortVergessen.TabOrder := 2;
    btnPasswortVergessen.TabStop := False;
    btnPasswortVergessen.WidthPercent := 100.000000000000000000;
    SetEvent(btnPasswortVergessen, Self, 'OnClick', 'btnPasswortVergessenClick');
    btnZugangAktivieren.SetParentComponent(BoxAnmeldung);
    btnZugangAktivieren.Name := 'btnZugangAktivieren';
    btnZugangAktivieren.Left := 11;
    btnZugangAktivieren.Top := 264;
    btnZugangAktivieren.Width := 161;
    btnZugangAktivieren.Height := 41;
    btnZugangAktivieren.Caption := 'Zugang aktivieren';
    btnZugangAktivieren.ChildOrder := 3;
    btnZugangAktivieren.ElementClassName := 'btn btn-sm btn-primary text-center mr-1';
    btnZugangAktivieren.ElementFont := efCSS;
    btnZugangAktivieren.HeightStyle := ssAuto;
    btnZugangAktivieren.HeightPercent := 100.000000000000000000;
    btnZugangAktivieren.TabOrder := 2;
    btnZugangAktivieren.TabStop := False;
    btnZugangAktivieren.WidthPercent := 100.000000000000000000;
    SetEvent(btnZugangAktivieren, Self, 'OnClick', 'btnZugangAktivierenClick');
    TC.SetParentComponent(PanelMain);
    TC.Name := 'TC';
    TC.Left := 56;
    TC.Top := 313;
    TC.Width := 279;
    TC.Height := 279;
    TC.ElementClassName := 'table table-bordered';
    TC.HeightStyle := ssAuto;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-info table-bordered ';
    TC.ColCount := 1;
    btnNachrichten.SetParentComponent(Self);
    btnNachrichten.Name := 'btnNachrichten';
    btnNachrichten.Left := 11;
    btnNachrichten.Top := 15;
    btnNachrichten.Width := 120;
    btnNachrichten.Height := 35;
    btnNachrichten.Caption := 'Nachrichten';
    btnNachrichten.ChildOrder := 9;
    btnNachrichten.ElementClassName := 'btn btn-info';
    btnNachrichten.ElementFont := efCSS;
    btnNachrichten.HeightStyle := ssAuto;
    btnNachrichten.HeightPercent := 100.000000000000000000;
    btnNachrichten.Visible := False;
    btnNachrichten.WidthPercent := 100.000000000000000000;
    SetEvent(btnNachrichten, Self, 'OnClick', 'btnNachrichtenClick');
    xdsAnmeldung.SetParentComponent(Self);
    xdsAnmeldung.Name := 'xdsAnmeldung';
    xdsAnmeldung.AfterOpen := xdsAnmeldungAfterOpen;
    xdsAnmeldung.EntitySetName := 'Adressen';
    xdsAnmeldung.Connection := DM2.XDataWebConnection1;
    xdsAnmeldung.Left := 112;
    xdsAnmeldung.Top := 8;
    xdsAnmeldungKundennummer.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungKundennummer.Name := 'xdsAnmeldungKundennummer';
    xdsAnmeldungKundennummer.FieldName := 'Kundennummer';
    xdsAnmeldungKundennummer.Required := True;
    xdsAnmeldungKundennummer.Size := 13;
    xdsAnmeldungLoginPW.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungLoginPW.Name := 'xdsAnmeldungLoginPW';
    xdsAnmeldungLoginPW.FieldName := 'LoginPW';
    xdsAnmeldungNachname.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungNachname.Name := 'xdsAnmeldungNachname';
    xdsAnmeldungNachname.FieldName := 'Nachname';
    xdsAnmeldungNachname.Size := 40;
    xdsAnmeldungVorname.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungVorname.Name := 'xdsAnmeldungVorname';
    xdsAnmeldungVorname.FieldName := 'Vorname';
    xdsAnmeldungVorname.Size := 40;
    xdsAnmeldungEMail.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungEMail.Name := 'xdsAnmeldungEMail';
    xdsAnmeldungEMail.FieldName := 'EMail';
    xdsAnmeldungEMail.Size := 50;
    xdsAnmeldungLoginAktiv.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungLoginAktiv.Name := 'xdsAnmeldungLoginAktiv';
    xdsAnmeldungLoginAktiv.FieldName := 'LoginAktiv';
    xdsAnmeldungPseudonymisiert.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungPseudonymisiert.Name := 'xdsAnmeldungPseudonymisiert';
    xdsAnmeldungPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsAnmeldungPseudonymisiert.Size := 255;
    xdsAnmeldungNichtInListeAnzeigen.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungNichtInListeAnzeigen.Name := 'xdsAnmeldungNichtInListeAnzeigen';
    xdsAnmeldungNichtInListeAnzeigen.FieldName := 'NichtInListeAnzeigen';
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.URL := 'https://www.cadia.de/myip.php';
    SetEvent(WebHttpRequest1, Self, 'OnError', 'WebHttpRequest1Error');
    SetEvent(WebHttpRequest1, Self, 'OnResponse', 'WebHttpRequest1Response');
    WebHttpRequest1.Left := 312;
    WebHttpRequest1.Top := 40;
    WebHttpRequest2.SetParentComponent(Self);
    WebHttpRequest2.Name := 'WebHttpRequest2';
    WebHttpRequest2.Headers.BeginUpdate;
    try
      WebHttpRequest2.Headers.Clear;
      WebHttpRequest2.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest2.Headers.EndUpdate;
    end;
    WebHttpRequest2.URL := './config/KundenportalConfig.cnf';
    SetEvent(WebHttpRequest2, Self, 'OnResponse', 'WebHttpRequest2Response');
    WebHttpRequest2.Left := 40;
    WebHttpRequest2.Top := 104;
    AuthConnection.SetParentComponent(Self);
    AuthConnection.Name := 'AuthConnection';
    AuthConnection.URL := 'https://salelite.com/cadiaserverauth';
    SetEvent(AuthConnection, Self, 'OnConnect', 'AuthConnectionConnect');
    AuthConnection.Left := 144;
    AuthConnection.Top := 40;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := AuthConnection;
    WClient.Left := 240;
    WClient.Top := 40;
    XDSVertreter.SetParentComponent(Self);
    XDSVertreter.Name := 'XDSVertreter';
    XDSVertreter.AfterOpen := XDSVertreterAfterOpen;
    XDSVertreter.EntitySetName := 'Vertreter';
    XDSVertreter.Connection := DM2.XDataWebConnection1;
    XDSVertreter.Left := 35;
    XDSVertreter.Top := 43;
    XDSVertreterKundennummer.SetParentComponent(XDSVertreter);
    XDSVertreterKundennummer.Name := 'XDSVertreterKundennummer';
    XDSVertreterKundennummer.FieldName := 'Kundennummer';
    XDSVertreterVertreterMatchcode.SetParentComponent(XDSVertreter);
    XDSVertreterVertreterMatchcode.Name := 'XDSVertreterVertreterMatchcode';
    XDSVertreterVertreterMatchcode.FieldName := 'VertreterMatchcode';
    XDSVertreterVertreterMatchcode.Required := True;
    XDSVertreterVertreterMatchcode.Size := 50;
    XDSVertreterVertreternummer.SetParentComponent(XDSVertreter);
    XDSVertreterVertreternummer.Name := 'XDSVertreterVertreternummer';
    XDSVertreterVertreternummer.FieldName := 'Vertreternummer';
    XDSVertreterVertreternummer.Size := 13;
    XDSVertreterNachname.SetParentComponent(XDSVertreter);
    XDSVertreterNachname.Name := 'XDSVertreterNachname';
    XDSVertreterNachname.FieldName := 'Nachname';
    XDSVertreterNachname.Size := 40;
    XDSVertreterVorname.SetParentComponent(XDSVertreter);
    XDSVertreterVorname.Name := 'XDSVertreterVorname';
    XDSVertreterVorname.FieldName := 'Vorname';
    XDSVertreterVorname.Size := 40;
    XDSVertreterProvisionssatz.SetParentComponent(XDSVertreter);
    XDSVertreterProvisionssatz.Name := 'XDSVertreterProvisionssatz';
    XDSVertreterProvisionssatz.FieldName := 'Provisionssatz';
    XDSVertreterVertreterStatus.SetParentComponent(XDSVertreter);
    XDSVertreterVertreterStatus.Name := 'XDSVertreterVertreterStatus';
    XDSVertreterVertreterStatus.FieldName := 'VertreterStatus';
    XDSVertreterVertreterStatus.Required := True;
    xdskdppw.SetParentComponent(Self);
    xdskdppw.Name := 'xdskdppw';
    xdskdppw.AfterOpen := xdskdppwAfterOpen;
    xdskdppw.EntitySetName := 'KundenportalPasswortVergessen';
    xdskdppw.Connection := DM2.XDataWebConnection1;
    xdskdppw.Left := 203;
    xdskdppw.Top := 11;
    xdskdppwLINKID.SetParentComponent(xdskdppw);
    xdskdppwLINKID.Name := 'xdskdppwLINKID';
    xdskdppwLINKID.FieldName := 'LINKID';
    xdskdppwLINKID.Required := True;
    xdskdppwLINKID.Size := 38;
    xdskdppwKundennummer.SetParentComponent(xdskdppw);
    xdskdppwKundennummer.Name := 'xdskdppwKundennummer';
    xdskdppwKundennummer.FieldName := 'Kundennummer';
    xdskdppwKundennummer.Required := True;
    xdskdppwKundennummer.Size := 13;
    xdskdppwDatum.SetParentComponent(xdskdppw);
    xdskdppwDatum.Name := 'xdskdppwDatum';
    xdskdppwDatum.FieldName := 'Datum';
    xdskdppwDatum.Required := True;
    xdskdppwBenutzt.SetParentComponent(xdskdppw);
    xdskdppwBenutzt.Name := 'xdskdppwBenutzt';
    xdskdppwBenutzt.FieldName := 'Benutzt';
  finally
    WebMessageDlg1.AfterLoadDFMValues;
    TopPanel.AfterLoadDFMValues;
    lblKundenportal.AfterLoadDFMValues;
    labelonlinestatus.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    btnKundendaten.AfterLoadDFMValues;
    btnSupportAnfordern.AfterLoadDFMValues;
    btnSupportTickets.AfterLoadDFMValues;
    btnRechnungen.AfterLoadDFMValues;
    btnBestellungen.AfterLoadDFMValues;
    WebHTMLDiv1.AfterLoadDFMValues;
    btnactivation.AfterLoadDFMValues;
    btnVertreterProvisionen.AfterLoadDFMValues;
    btnSupportKonto.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    buttonDatenschutz.AfterLoadDFMValues;
    buttonAGB.AfterLoadDFMValues;
    buttonImpressum.AfterLoadDFMValues;
    buttonLogout.AfterLoadDFMValues;
    PanelMain.AfterLoadDFMValues;
    labelversion.AfterLoadDFMValues;
    panelCookies.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    btnCookiesEinverstanden.AfterLoadDFMValues;
    btnNoCookies.AfterLoadDFMValues;
    btnCookieInfo.AfterLoadDFMValues;
    BoxAnmeldung.AfterLoadDFMValues;
    lblchecklogin.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    edtBenutzer.AfterLoadDFMValues;
    edtPassword.AfterLoadDFMValues;
    buttonLogin.AfterLoadDFMValues;
    btnPasswortVergessen.AfterLoadDFMValues;
    btnZugangAktivieren.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    btnNachrichten.AfterLoadDFMValues;
    xdsAnmeldung.AfterLoadDFMValues;
    xdsAnmeldungKundennummer.AfterLoadDFMValues;
    xdsAnmeldungLoginPW.AfterLoadDFMValues;
    xdsAnmeldungNachname.AfterLoadDFMValues;
    xdsAnmeldungVorname.AfterLoadDFMValues;
    xdsAnmeldungEMail.AfterLoadDFMValues;
    xdsAnmeldungLoginAktiv.AfterLoadDFMValues;
    xdsAnmeldungPseudonymisiert.AfterLoadDFMValues;
    xdsAnmeldungNichtInListeAnzeigen.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    WebHttpRequest2.AfterLoadDFMValues;
    AuthConnection.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
    XDSVertreter.AfterLoadDFMValues;
    XDSVertreterKundennummer.AfterLoadDFMValues;
    XDSVertreterVertreterMatchcode.AfterLoadDFMValues;
    XDSVertreterVertreternummer.AfterLoadDFMValues;
    XDSVertreterNachname.AfterLoadDFMValues;
    XDSVertreterVorname.AfterLoadDFMValues;
    XDSVertreterProvisionssatz.AfterLoadDFMValues;
    XDSVertreterVertreterStatus.AfterLoadDFMValues;
    xdskdppw.AfterLoadDFMValues;
    xdskdppwLINKID.AfterLoadDFMValues;
    xdskdppwKundennummer.AfterLoadDFMValues;
    xdskdppwDatum.AfterLoadDFMValues;
    xdskdppwBenutzt.AfterLoadDFMValues;
  end;
end;

end.